




























import {Component, PropSync, Watch} from 'vue-property-decorator'
import {Getter, Action} from "vuex-class";
import {SelectWings, ToggleWings, FilterWings} from '@/components';
import {DistributionFilter} from "@/store/templates/types";
import FilterSelectedItemWings from "@/components/Filter/FilterSelectedItemWings.vue";
import {notifyError, notifyWarning} from "@/utils/notify-helper";
import BaseFilter from "@/components/Filter/BaseFilter";

@Component({components: {FilterSelectedItemWings, SelectWings, ToggleWings, FilterWings}})
export default class DistributionsFilter extends BaseFilter<DistributionFilter> {
  @PropSync('show') is_show!: boolean;
  @PropSync("filterClone") propFilterClone!: any;
  @PropSync('runFilter') propRunFilter!: boolean;
  @Action("getDistributions") actionGetDistributions: any;

  private statuses = [
    'GENERATED', 'PAYMENT_WAITING', 'IN_PROGRESS', 'ON_MODERATION', 'DENIED', 'PAUSED', 'STOPPED', 'ERROR', 'FINISHED'
  ]

  defaultFilter(): DistributionFilter {
    return {
      name: null,
      transport: null,
      status: null,
      comment: null,
    }
  }

  created() {
    this.filtered();
    this.scroll();
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      const resp = await this.actionGetDistributions(this.filter);
      if (resp.data.length == 0) {
        if (!nextPage) notifyWarning()
        this.is_last = true
      } else {
        this.is_last = false
      }
    } catch(error) {
      notifyError(error);
    } finally {
      this.moreLoading = false
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChange(val: any) {
    this.propFilterClone = val;
  }

  @Watch('runFilter')
  onRunFilterChange(val: boolean) {
    if (!val) return;
    this.filtered();
    this.propRunFilter = false;
  }

}
